export const sortedShipumDimension = (length: number, width: number, height: number) => {
  const s = [length, width, height].sort((a, b) => a - b);
  return { height: s[0], width: s[1], length: s[2] };
};
